import request from '@/utils/request'

export function queryLocatins(data) {
    return request({
        url: '/api-admin/location/queryLocations',
        method: 'get',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
        },
        params: data
    })
}

export function getAllDeviceNames(data) {
    return request({
        url: '/api-admin/location/getAllDeviceNames',
        method: 'get',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
        }
    })
}